export default "__VITE_PUBLIC_ASSET__271857a4__"